import React, { useState } from 'react';
import { Dropdown } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faChartBar, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../context/ThemeContext';
import { ChartSelectionProps, ChartType } from './types';
import {
  StyledButton,
  DropdownContainer,
  DropdownTitle,
  RadioGroupContainer,
  RadioItem,
  RadioItemContent,
  RadioItemLabel,
  IconWrapper,
  Divider,
  StyledRadio,
  ButtonTextContainer,
  ButtonLabel,
  ButtonValue,
} from './styles';

const ChartSelection: React.FC<ChartSelectionProps> = ({
  onChange,
  defaultValue = 'line',
  value: controlledValue,
}) => {
  const [selectedType, setSelectedType] = useState<ChartType>(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  const currentValue = controlledValue !== undefined ? controlledValue : selectedType;

  const handleSelection = (newValue: ChartType) => {
    if (controlledValue === undefined) {
      setSelectedType(newValue);
    }
    onChange(newValue);
  };

  return (
    <Dropdown
      trigger={['click']}
      open={isOpen}
      onOpenChange={setIsOpen}
      dropdownRender={() => (
        <DropdownContainer theme={theme}>
          <DropdownTitle theme={theme}>Graph type</DropdownTitle>
          <RadioGroupContainer>
            <RadioItem onClick={() => handleSelection('line')}>
              <RadioItemContent>
                <IconWrapper theme={theme}>
                  <FontAwesomeIcon icon={faChartLine} />
                </IconWrapper>
                <RadioItemLabel theme={theme}>Line</RadioItemLabel>
              </RadioItemContent>
              <StyledRadio checked={currentValue === 'line'} theme={theme} />
            </RadioItem>
            <Divider theme={theme} />
            <RadioItem onClick={() => handleSelection('bar')}>
              <RadioItemContent>
                <IconWrapper theme={theme}>
                  <FontAwesomeIcon icon={faChartBar} />
                </IconWrapper>
                <RadioItemLabel theme={theme}>Bar</RadioItemLabel>
              </RadioItemContent>
              <StyledRadio checked={currentValue === 'bar'} theme={theme} />
            </RadioItem>
          </RadioGroupContainer>
        </DropdownContainer>
      )}
    >
      <StyledButton theme={theme} onClick={(e) => e.preventDefault()}>
        <ButtonTextContainer theme={theme}>
          <ButtonLabel theme={theme}>View</ButtonLabel>
          <ButtonValue theme={theme}>{currentValue === 'line' ? 'Line' : 'Bar'}</ButtonValue>
        </ButtonTextContainer>
        <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
      </StyledButton>
    </Dropdown>
  );
};

export default ChartSelection;
